<template>
  <multiselect
    :value="computedValue"
    :options="options"
    :searchable="false"
    :showLabels="false"
    @input="onChange"
  >
    <template #option="{option}">
      {{ option }}%
    </template>
  </multiselect>
</template>

<script>
export default {
  props: {
    value: Number,
    options: Array,
    onChange: Function
  },
  computed: {
    computedValue () {
      const { value } = this
      return value ? `${value}%` : '0%'
    }
  }
}
</script>
